import React from 'react';

// CB:BEGIN email-preview-start-reminder
const EmailStartReminder: React.FC = () => {
  const date = 'Aug 16, 2025';
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '600px', margin: '0 auto', padding: 20 }}>
      <div style={{ background: '#f59e0b', padding: 20, borderRadius: 8, marginBottom: 20, textAlign: 'center' }}>
        <h2 style={{ color: 'white', margin: 0 }}>⚠️ Project Starting Tomorrow!</h2>
      </div>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        This is a friendly reminder that your roofing project begins tomorrow, <strong>{date}</strong>.
      </p>
      <div style={{ background: '#fef3c7', padding: 15, borderRadius: 6, margin: '20px 0', borderLeft: '4px solid #f59e0b' }}>
        <p style={{ fontSize: 16, fontWeight: 600, margin: 0, color: '#92400e' }}>
          <strong>Action Required:</strong> Please ensure your property is ready and accessible for the contractor team.
        </p>
      </div>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}><strong>Preparation checklist:</strong></p>
      <ul style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        <li>Clear access to your roof and property</li>
        <li>Remove vehicles from driveway if needed</li>
        <li>Secure pets indoors during work hours</li>
        <li>Ensure contractor has your contact number</li>
      </ul>
      <hr style={{ border: 'none', borderTop: '1px solid #e2e8f0', margin: '30px 0' }} />
      <p style={{ fontSize: 12, color: '#6b7280', textAlign: 'center' }}>
        From: CoreBids Notifications &lt;notifications@corebids.com&gt;<br />
        This mailbox isn't monitored. Please don't reply. Contact support via your dashboard.
      </p>
    </div>
  );
};

export default EmailStartReminder;
// CB:END email-preview-start-reminder


